import { useSearchFiltersSlice } from "@redux/slices/searchFilters";
import { useCallback } from "react";

const useColorFilterSelection = (sectionName: any) => {
  const { auxPayload: filtersPayload } = useSearchFiltersSlice();

  const isWhiteColorsSelected = useCallback(() => {
    const colorFrom = filtersPayload?.[sectionName]?.color_from;
    const colorTo = filtersPayload?.[sectionName]?.color_to;
    return colorFrom !== undefined || colorTo !== undefined;
  }, [filtersPayload, sectionName]);

  const isFancyColorsSelected = useCallback(() => {
    const fancyColors = filtersPayload?.[sectionName]?.fancy_colors;
    return fancyColors !== undefined && fancyColors?.length > 0;
  }, [filtersPayload, sectionName]);

  const isOvertonesSelected = useCallback(() => {
    const overtones = filtersPayload?.[sectionName]?.fancy_color_overtones;
    return overtones !== undefined && overtones?.length > 0;
  }, [filtersPayload, sectionName]);

  const isIntensitiesSelected = useCallback(() => {
    const intensityFrom =
      filtersPayload?.[sectionName]?.fancy_color_intensity_from;
    const intensityTo = filtersPayload?.[sectionName]?.fancy_color_intensity_to;
    return intensityFrom !== undefined || intensityTo !== undefined;
  }, [filtersPayload, sectionName]);

  const isArgyleSelected = useCallback(() => {
    const argyle = filtersPayload?.[sectionName]?.argyle;
    return (
      argyle !== undefined &&
      Object.keys(filtersPayload[sectionName].argyle).length > 0
    );
  }, [filtersPayload, sectionName]);

  return {
    isWhiteColorsSelected,
    isFancyColorsSelected,
    isOvertonesSelected,
    isIntensitiesSelected,
    isArgyleSelected,
  };
};

export default useColorFilterSelection;
